import "./template.marko?hydrate";
window.$initComponents && $initComponents();
